import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rmsSortByFunction',
    standalone: false
})
export class RmsSortByFunctionPipe implements PipeTransform {

  transform<T>(value: Array<T>, pred: (a: T, b: T) => number): any {
    return value.sort(pred);
  }

}
